export default "__VITE_ASSET__BtVDbtnc__"